import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import th from "./locales/th.json";
import en from "./locales/en.json";
import my from "./locales/my.json";

const STORAGE_KEY = "scp-locale";
const savedLocale = localStorage.getItem(STORAGE_KEY) || "th";

i18n.use(initReactI18next).init({
  resources: {
    th: { translation: th },
    en: { translation: en },
    my: { translation: my },
  },
  lng: savedLocale,
  fallbackLng: "th",
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (lng) => {
  localStorage.setItem(STORAGE_KEY, lng);
});

export default i18n;
